import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';

import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const webPractic = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img1.png',
            crewItemTitle: 'Анастасия Андронова',
            crewItemSubtitle: 'руководитель подразделения Вебпрактик.Маркетинг ',
        },
        {
            crewItemImg: '/images/svg/skolkovo/ace-ventura.jpg',
            crewItemTitle: 'Ксения Жукова',
            crewItemSubtitle: 'старший менеджер проектов',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Евгения Шестакова',
            crewItemSubtitle: 'руководитель отдела таргетинга',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Ангелина Попова',
            crewItemSubtitle: 'маркетолог',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Елена Морозова',
            crewItemSubtitle: 'маркетолог',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'старший веб-дизайнер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Анна Сластен',
            crewItemSubtitle: 'дизайнер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Петр Кленкин',
            crewItemSubtitle: 'backend-разработчик',
        },
    ],
};

const techParkSkolkkovo = {
    crewTitle: 'Технопарк «Сколково»',
    crewSubtitle:
        'Выражаем благодарность команде Сколково за&nbsp;помощь в&nbsp;работе над проектом:',
    crewList: [
        {
            crewItemImg: null,
            crewItemTitle: 'Мария Кравченко',
            crewItemSubtitle: 'руководитель департамента внешних коммуникаций',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Дарья Галкина',
            crewItemSubtitle: 'руководитель волонтерского кампуса',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Ирина Рогинская и Мина Мурадова',
            crewItemSubtitle: 'ответственные за направление «Конгресс-центр»',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Елена Михайлевская',
            crewItemSubtitle: 'ответственная за направление «Коворкинг»',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Наталья Кучина и Наталья Баида',
            crewItemSubtitle: 'ответственные за направление «Экскурсии»',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Мария Иванова',
            crewItemSubtitle: 'руководитель направления «Сообщества для инвесторов»',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper className="team">
                    <CommonTitle>Команда</CommonTitle>
                    <CommonUsualText className="team__text-info">
                        Каждому клиенту мы&nbsp;предоставляем отдельную проектную команду.
                        Над&nbsp;продвижением всех направлений Технопарка &laquo;Сколково&raquo;
                        работали 8&nbsp;человек с&nbsp;нашей стороны и&nbsp;7 человек
                        со&nbsp;стороны заказчика:
                    </CommonUsualText>
                    <CrewContainer container={webPractic} />
                    <CrewContainer container={techParkSkolkkovo} />
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Team;
